import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: ['teamId'],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        title: "",
        training_time: "",
        is_mandatory: "",
        description: {
          note: '',
          content_text: ''
        },
        note: '',
        content_text: '',
        duration: ""
      },
      rules: {
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        training_time: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        is_mandatory: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        duration: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData.id = datas.training_plan_id;
                  _this.formData.title = datas.title;
                  _this.formData.is_mandatory = datas.is_mandatory;
                  _this.formData.description = datas.description ? JSON.parse(datas.description) : {};
                  _this.formData.duration = datas.duration;
                  _this.formData.training_time = datas.training_time;
                  _this.formData.content_text = datas.content_text;
                  _this.formData.note = datas.note;

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.formData = {
        id: '',
        title: "",
        training_time: "",
        is_mandatory: "",
        description: {
          note: '',
          content_text: ''
        },
        note: '',
        content_text: '',
        duration: ""
      };
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this2.formData.id ? 'trainingsUpd' : 'trainingsAdd';
                    _this2.formData.description = {};
                    _this2.formData.description.content_text = _this2.formData.content_text || '';
                    _this2.formData.description.note = _this2.formData.note;
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                      team_id: _this2.teamId
                    })).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success('操作成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};